import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
export default fillCrudMetadataGaps({
  label: 'Dispositivos MFA',
  labelPlural: 'Dispositivos MFA',
  name: 'UserMFADevice',
  namePlural: 'UserMFADevices',
  authorization: authorization('clientConsultant', 'clientConsultant'),
  custom_withAudit: true,
  deletable: false,
  insertable: false,
  dynamoDB: {
    tableName: 'SpearUserMFADevice'
  },
  columns: ['id', 'name', 'email', 'type', 'retries', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    name: 'type',
    label: 'Tipo',
    type: 'text',
    updatable: false,
    required: true,
    options: [{
      label: 'Aplicativo',
      value: 'TOTP'
    }, {
      label: 'E-mail',
      value: 'EMAIL'
    }]
  }, {
    name: 'email',
    label: 'Email',
    type: 'text',
    updatable: false
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: false,
    required: true,
    type: 'boolean'
  }, {
    name: 'retries',
    label: 'Retentativas',
    type: 'int'
  }
  // {
  //   name: 'secretKeyEncrypted',
  //   label: 'Senha',
  //   default: false,
  //   required: true,
  //   updatable: false,
  //   type: 'text',
  // },
  // {
  //   name: 'kmsKeyId',
  //   label: 'Id da chave no KMS',
  //   default: false,
  //   required: true,
  //   type: 'text',
  //   render: false,
  // },
  ],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }, {
    name: 'id_beginsWith',
    field: 'id',
    op: 'beginsWith',
    label: 'Id'
  }]
});